"use client";

import { useEffect } from "react";

import { DRAFT_PREVIEW_PATH } from "@/utils/draftPreview";

const LAST_REDIRECT_KEY = "isov-draft-preview-redirected-at";
const RETRY_AFTER_MS = 10_000;

// Rendered only into cached pages on draft-preview sites, i.e. when the visitor
// is not (or no longer, after a deploy) in Draft Mode. Sends them through it
// once; the retry window stops a loop if the browser refuses the cookie.
export default function DraftPreviewRedirect() {
  useEffect(() => {
    const lastRedirectAt = Number(sessionStorage.getItem(LAST_REDIRECT_KEY));
    if (Date.now() - lastRedirectAt < RETRY_AFTER_MS) return;

    const redirect = () => {
      sessionStorage.setItem(LAST_REDIRECT_KEY, String(Date.now()));
      const { pathname, search, hash } = window.location;
      window.location.replace(
        `${DRAFT_PREVIEW_PATH}?redirect=${encodeURIComponent(pathname + search + hash)}`,
      );
    };

    // Leaving while the HTML is still streaming in (pages render per request
    // in next dev) cuts React off mid-page, which it reports as "could not
    // finish this Suspense boundary" errors, so wait for the HTML to finish.
    if (document.readyState !== "loading") return redirect();
    document.addEventListener("DOMContentLoaded", redirect, { once: true });
    return () => document.removeEventListener("DOMContentLoaded", redirect);
  }, []);

  return null;
}
